module.exports = __webpack_public_path__ + "static/media/Jason Bourne 1000*1500.0594dcc1.jpg";